export const HEADER_HEIGHT = 48;
export const TOOLBAR_HEIGHT = 40;
export const SIDE_BAR_WIDTH = 220;
export const SIDE_BAR_WIDTH_COLLAPSED = 0;
export const TABLE_FOOTER_HEIGHT = 48;
export const TABLE_FILTER_BAR_HEIGHT = 96;
export const FORM_FOOTER_HEIGHT = 60;
export const CONTAINER_PADDING_Y = 18;
